import { string } from "prop-types";

export const Choice = {
  id: string,
  label: string,
};
